module.exports = __webpack_public_path__ + "static/BG_Image-26c9a6aba3dcda84dc043718b9f93fc1.png";